import React, { useState, useEffect } from 'react';
import { fetchWithCSRF } from '../utils/csrfUtils';
import supabase from '../supabaseClient';


const CuisinePreferencesStep = ({ onSave, initialValues = [], sessionToken }) => {
    const [cuisines, setCuisines] = useState([]);
    const [selectedCuisines, setSelectedCuisines] = useState(initialValues);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchCuisines = async () => {
            try {
                if (!sessionToken) {
                    console.error('No session token available');
                    return;
                }
                
                const response = await fetchWithCSRF('/api/v1/cuisine', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${sessionToken}`
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    setCuisines(data);
                    
                    // Preload images immediately after fetching cuisines
                    data.forEach(cuisine => {
                        const img = new Image();
                        img.src = `/icons/cuisineOptions/${cuisine.name.replace(/\s+/g, '')}.png`;
                    });
                }
            } catch (error) {
                console.error('Error fetching cuisines:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCuisines();
    }, [sessionToken]);

    const handleCuisineToggle = (cuisineId) => {
        setSelectedCuisines(prev => 
            prev.includes(cuisineId)
                ? prev.filter(id => id !== cuisineId)
                : [...prev, cuisineId]
        );
    };

    const handleSelectAll = () => {
        const allCuisineIds = cuisines.map(cuisine => cuisine.id);
        setSelectedCuisines(allCuisineIds);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Only proceed if at least 3 cuisines are selected
        if (selectedCuisines.length >= 3) {
            onSave(selectedCuisines, false);
        }
    };

    if (loading) {
        return <div className="text-center">Loading cuisines...</div>;
    }

    return (
        <div className="preference-step">
            <h2>What kinds of cuisines do you love?</h2>
            <p className="mb-0">We'll use this to recommend meals that fit your taste.</p>
            <p>Select at least 3 cuisines to continue.</p>
            
            <form onSubmit={handleSubmit}>
                <div className="cuisine-options-grid">
                    {cuisines.map(cuisine => (
                        <button
                            key={cuisine.id}
                            type="button"
                            className={`cuisine-selection-button ${selectedCuisines.includes(cuisine.id) ? 'active' : ''}`}
                            onClick={() => handleCuisineToggle(cuisine.id)}
                        >
                            <img 
                                src={`/icons/cuisineOptions/${cuisine.name.replace(/\s+/g, '')}.svg`}
                                alt={`${cuisine.name} icon`}
                                className="cuisine-button-icon"
                                onError={(e) => {
                                    // Fallback to PNG if SVG doesn't exist
                                    e.target.src = `/icons/cuisineOptions/${cuisine.name.replace(/\s+/g, '')}.png`;
                                }}
                            />
                            <span>{cuisine.name}</span>
                        </button>
                    ))}
                </div>
                
                <div className="d-flex justify-content-between align-items-center">
                    <button type="button" className="btn btn-secondary" onClick={() => onSave(null, true)}>Back</button>
                    <button 
                        type="button" 
                        className="btn btn-outline-primary"
                        onClick={handleSelectAll}
                    >
                        Select All
                    </button>
                    <button 
                        type="submit" 
                        className={`btn btn-primary ${selectedCuisines.length < 3 ? 'disabled' : ''}`}
                        disabled={selectedCuisines.length < 3}
                        title={selectedCuisines.length < 3 ? `Please select at least 3 cuisines (${3 - selectedCuisines.length} more needed)` : ""}
                    >
                        Continue
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CuisinePreferencesStep; 